import { Select } from 'antd'
import React from 'react'
import CompDatePicker from '../../components/compDatePicker/_CompDatePicker'

const HouseDetails = () => {
    return (
        <>
            <div className="parameter-row">
                <div className="tab-content-title section-title">
                    פרטי ביטוח דירה
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סוג ביטוח
                        </div>
                        <div className="value">
                            <Select
                                value={'בחר סוג ביטוח'}
                                style={{ width: '100%' }}
                                options={[
                                    {
                                        label: 'מקיף',
                                        value: '1'
                                    },
                                    {
                                        label: 'כה"ס',
                                        value: '2'
                                    }
                                ]}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סוג כיסוי
                        </div>
                        <div className="value">
                            <Select
                                value={'בחר סוג כיסוי'}
                                style={{ width: '100%' }}
                                options={[
                                    {
                                        label: 'מבנה',
                                        value: '1'
                                    },
                                    {
                                        label: 'תכולה',
                                        value: '2'
                                    },
                                    {
                                        label: 'מבנה ותכולה',
                                        value: '3'
                                    }
                                ]}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            כתובת
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            מבנה
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            תכולה
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            %משווי התכולה
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            ר. אדמה (מבנה)
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            ר. אדמה (תכולה)
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            תאריך סקר
                        </div>
                        <div className="value">
                            <CompDatePicker value={null} onChange={(date: Date) => { }} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            מ"ר
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            תכשיטים
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            שם הסוקר
                        </div>
                        <div className="value">
                            <input type='text' value={''} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>

                </div>
                <div className={`parameter-item`}>

                </div>
                <div className={`parameter-item`}>

                </div>
                <div className={`parameter-item`}>

                </div>
            </div>
            <div className="parameter-row">
                <div className="tab-content-title section-title">
                    הרחבות
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            צד ג'
                        </div>
                        <div className="value">
                            <Select
                                value={'צד ג\''}
                                style={{ width: '100%' }}
                                options={[
                                    {
                                        label: 'כן',
                                        value: '1'
                                    },
                                    {
                                        label: 'לא',
                                        value: '2'
                                    }
                                ]}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            חבות מעבידים
                        </div>
                        <div className="value">
                            <Select
                                value={'חבות מעבידים'}
                                style={{ width: '100%' }}
                                options={[
                                    {
                                        label: 'כן',
                                        value: '1'
                                    },
                                    {
                                        label: 'לא',
                                        value: '2'
                                    }
                                ]}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            שרברב הסדר
                        </div>
                        <div className="value">
                            <Select
                                value={'שרברב הסדר'}
                                style={{ width: '100%' }}
                                options={[
                                    {
                                        label: 'כן',
                                        value: '1'
                                    },
                                    {
                                        label: 'לא',
                                        value: '2'
                                    }
                                ]}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>

                </div>
                <div className={`parameter-item`}>

                </div>
                <div className={`parameter-item`}>

                </div>
            </div>
        </>
    )
}

export default HouseDetails